import { render } from "./PendingApprovalsList.vue?vue&type=template&id=7251998d&scoped=true"
import script from "./PendingApprovalsList.vue?vue&type=script&lang=js"
export * from "./PendingApprovalsList.vue?vue&type=script&lang=js"

import "./PendingApprovalsList.vue?vue&type=style&index=0&id=7251998d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7251998d"]])

export default __exports__